<template>
  <v-simple-table>
    <tbody>
      <tr>
        <td><strong>{{ $t('oferta.labels.nombre') }}</strong></td>
        <td>{{ item.nombre }}</td>
      </tr>
      <tr v-if="item.descripcion">
        <td><strong>{{ $t('oferta.labels.descripcion') }}</strong></td>
        <td>{{ item.descripcion }}</td>
      </tr>
      <tr>
        <td><strong>{{ $t('oferta.labels.tipo') }}</strong></td>
        <td>{{ getTipoLabel(item.tipo) }}</td>
      </tr>
      <tr v-if="item.tipo === 'porcentaje' && item.valor">
        <td><strong>{{ $t('oferta.labels.valor') }}</strong></td>
        <td>{{ item.valor }}%</td>
      </tr>
      <tr v-if="item.tipo === 'por_cantidad' && item.cantidadMinima != null">
        <td><strong>{{ $t('oferta.labels.cantidadMinima') }}</strong></td>
        <td>{{ item.cantidadMinima }}</td>
      </tr>
      <tr v-if="item.tipo === 'por_cantidad' && item.valor != null">
        <td><strong>{{ $t('oferta.labels.valor') }}</strong></td>
        <td>{{ item.valor }}%</td>
      </tr>
      <tr>
        <td><strong>{{ $t('oferta.labels.productos') }}</strong></td>
        <td>
          <span v-if="item.productos && item.productos.length > 0">
            {{ item.productos.length }} productos
          </span>
          <span v-else>-</span>
        </td>
      </tr>
      <tr>
        <td><strong>{{ $t('oferta.labels.deposito') }}</strong></td>
        <td>{{ item.deposito ? item.deposito.nombre : '-' }}</td>
      </tr>
      <tr>
        <td><strong>{{ $t('oferta.labels.diasSemana') }}</strong></td>
        <td>
          <span v-if="item.diasSemana && item.diasSemana.length > 0">
            {{ item.diasSemana.length === 7 ? $t('oferta.labels.todosLosDias') : item.diasSemana.join(', ') }}
          </span>
          <span v-else>-</span>
        </td>
      </tr>
      <tr>
        <td><strong>{{ $t('oferta.labels.fechaInicio') }}</strong></td>
        <td>{{ item.fechaInicio ? getDateTimeFormat(item.fechaInicio) : '-' }}</td>
      </tr>
      <tr>
        <td><strong>{{ $t('oferta.labels.fechaFin') }}</strong></td>
        <td>{{ item.fechaFin ? getDateTimeFormat(item.fechaFin) : $t('oferta.labels.sinFechaLimite') }}</td>
      </tr>
      <tr>
        <td><strong>{{ $t('oferta.labels.mediosPago') }}</strong></td>
        <td>
          <span v-if="item.mediosPago && item.mediosPago.length > 0">
            {{ item.mediosPago.join(', ') }}
          </span>
          <span v-else>-</span>
        </td>
      </tr>
      <tr>
        <td><strong>{{ $t('oferta.labels.activa') }}</strong></td>
        <td>
          <v-chip small :color="item.activa ? 'green' : 'red'" dark>
            {{ item.activa ? $t('common.active') : $t('common.inactive') }}
          </v-chip>
        </td>
      </tr>
    </tbody>
  </v-simple-table>
</template>

<script>
import { DayjsMixin } from "@dracul/dayjs-frontend";

export default {
  name: "OfertaShowData",
  mixins: [DayjsMixin],
  props: {
    item: { type: Object, required: true },
  },
  methods: {
    getTipoLabel(tipo) {
      return this.$t(`oferta.labels.${tipo}`);
    },
  },
};
</script>

<style scoped></style>

